export default function Events() {
  return (
    <div className="events">
      <h1>Couses & Events</h1>
      <p>Sign-Up Coming Soon</p>
    </div>
  );
}
